import React from "react";
import { graphql } from "gatsby";
import { motion } from "framer-motion";
import { PrismicRichText } from "@prismicio/react";
import { GatsbyImage } from "gatsby-plugin-image";
import ReactPlayer from "react-player/lazy";
import Icon from "../../components/Icon";
import VisuallyHidden from "../../components/VisuallyHidden";
import * as styles from "./featured-video.module.css";

const ReactPlayerWrapper = ({ children }) => {
  return <div style={{ width: "100%", height: "100%" }}>{children}</div>;
};

export const FeaturedVideo = ({ slice }) => {
  const [isPlaying, setIsPlaying] = React.useState(false);
  const { heading, video_poster, video_link } = slice?.primary || {};

  return (
    <section
      className={styles.container}
      data-color-scheme="black"
      data-tilt-scheme="center"
      data-video-playing={isPlaying}
    >
      <div className={"section-split-6-5 page-width " + styles.content}>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
        >
          {heading && (
            <PrismicRichText
              field={heading.richText}
              components={{
                heading2: ({ children }) => <h2 className="h0">{children}</h2>,
              }}
            />
          )}
        </motion.div>
        <motion.button
          className={styles.playButton}
          onClick={() => setIsPlaying(true)}
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, delay: 0.2, ease: [0.25, 0.1, 0.25, 1] }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <Icon name="play" size="var(--icon-size, 24rem)" />
          <VisuallyHidden>Play video</VisuallyHidden>
        </motion.button>
      </div>
      <div className={styles.videoWrapper}>
        <div className={styles.videoWrapperInner}>
          {video_link && (
            <ReactPlayer
              url={video_link.url}
              style={{ width: "100%", height: "100%" }}
              wrapper={ReactPlayerWrapper}
              playing={isPlaying}
              controls={true}
              onEnded={() => setIsPlaying(false)}
              onPause={() => setIsPlaying(false)}
            />
          )}
          {video_poster && (
            <GatsbyImage
              image={video_poster.gatsbyImageData}
              alt=""
              className={styles.poster}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export const query = graphql`
  fragment HomepageDataBodyFeaturedVideo on PrismicHomepageDataBodyFeaturedVideo {
    primary {
      heading {
        richText
      }
      video_poster {
        gatsbyImageData(placeholder: BLURRED)
      }
      video_link {
        url
      }
    }
  }
`;
